export const CNEE_ADDRESS_DISCOUNT_CVS_ERROR = 'CneeAddrDiscNoSupportCvs'
export const CVS_UNAVAILABLE_STAGE = 'cvs-unavailable'

const CVS_CARRIERS = new Set(['cvs', '711', '7-11'])

export function isCvsCarrier (carrier) {
  return CVS_CARRIERS.has(String(carrier || '').toLowerCase())
}

export function hasCneeAddressDiscount (prepareModel) {
  return Boolean(prepareModel?.shippingRates?.some(rate => {
    return rate.parcelsFeeFormulas?.cneeAddressDiscount
  }))
}

export function hasSeaExpressRate (prepareModel) {
  return Boolean(prepareModel?.shippingRates?.some(rate => rate.transport === 'se'))
}

export function hasUnavailableCvsSelection ({
  deliveryMode,
  jyoCarrier,
  cvsAvailable,
}) {
  const isCvsMode = deliveryMode === 'cvs'
  const hasCvsCarrier = isCvsCarrier(jyoCarrier)
  return (!cvsAvailable && (isCvsMode || hasCvsCarrier)) ||
    (!isCvsMode && hasCvsCarrier)
}

export function resolveCreateJyoCarrier ({
  deliveryMode,
  jyoCarrier,
  fallbackCarrier,
}) {
  if (deliveryMode === 'cvs') return 'cvs'
  const normalizedCarrier = isCvsCarrier(jyoCarrier) ? '' : jyoCarrier
  const normalizedFallback = isCvsCarrier(fallbackCarrier) ? '' : fallbackCarrier
  return normalizedCarrier || normalizedFallback
}

export function getUnavailableCvsMessage ({
  prepareModel,
  carrierError = '',
  forceAddressDiscount = false,
} = {}) {
  if (forceAddressDiscount || hasCneeAddressDiscount(prepareModel)) {
    return hasSeaExpressRate(prepareModel)
      ? '學生宿舍優惠僅適用海快，且不支援 7-11 到店自取。請改選海快並使用宅配。'
      : '此批貨物無法使用海快，因此無法套用學生宿舍優惠；優惠地址亦不支援 7-11 到店自取。請改選宅配或更換一般收件地址。'
  }
  if (carrierError) {
    return `7-11 到店自取無法使用：${carrierError}。已改回宅配，請重新確認配送方式。`
  }
  return '7-11 到店自取目前無法使用，已改回宅配，請重新確認配送方式。'
}
